<div class="MainContainer">
    <div class="container">
        <div class="loginBox">
            <div class="formPanel" *ngIf="IsChangePasswordform">
                <div class="title">
                    <h4>Reset Password</h4>
                </div>
                <div class="contentTab">
                    <form [formGroup]="ResetPaswordForm" (ngSubmit)="isSubmitClicked=true;onSubmit()">
                        <div class="form-content">
                            <div class="row">
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="newPassword" class="form-label">New Password<span
                                                class="req">*</span></label>
                                        <input [type]="showPassword ? 'text' : 'password'" formControlName="newPassword"
                                            (keydown.space)="$event.preventDefault()" class="form-control"
                                            [ngClass]="{ 'is-invalid': Submited && ResetPaswordForm.get('newPassword')?.errors }"
                                            autocomplete="off" minlength="8" maxlength="25"
                                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                                            (keyup)="checkConfirm($event)" />
                                        <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibility()">
                                            {{showPassword?'visibility':'visibility_off'}}
                                        </mat-icon>
                                        <div *ngIf="Submited && ResetPaswordForm.get('newPassword')?.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="ResetPaswordForm.get('newPassword')?.errors?.['required']">New
                                                password is required</div>
                                            <div *ngIf="ResetPaswordForm.get('newPassword')?.errors?.['pattern']">
                                                Password must be at least 8 characters and include one lowercase,
                                                uppercase, digit, and special character.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="confirmPassword" class="form-label">Confirm Password<span
                                                class="req">*</span></label>
                                        <input [type]="showPasswordC ? 'text' : 'password'"
                                            formControlName="confirmPassword" autocomplete="off"
                                            (keydown.space)="$event.preventDefault()" class="form-control"
                                            [ngClass]="{ 'is-invalid': Submited && ResetPaswordForm.get('confirmPassword')?.errors }"
                                            minlength="8" maxlength="25"
                                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                                            (keyup)="checkConfirm($event)" />
                                        <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibilityC()">
                                            {{showPasswordC?'visibility':'visibility_off'}}
                                        </mat-icon>
                                        <div *ngIf="Submited && ResetPaswordForm.get('confirmPassword')?.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="ResetPaswordForm.get('confirmPassword')?.errors?.['required']">
                                                Confirm password is required</div>
                                            <div *ngIf="ResetPaswordForm.get('confirmPassword')?.errors?.['pattern']">
                                                Password must be at least 8 characters and include one lowercase,
                                                uppercase, digit, and special character.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-danger" *ngIf="NotMatch">
                                <p>Passwords do not match. Please re-enter the password.</p>
                            </div>
                        </div>
                        <div class="modal-footer pb-0">
                            <button class="btn btn-primary" [disabled]="isSubmitClicked">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="SuccessfulClass" *ngIf="!IsChangePasswordform">
                <h2>Password Changed Successfully</h2>
                <p><a class="btn-link" (click)="redirectToLogin()" style="color: blue">Click Here</a> to login. </p>
            </div>
        </div>
    </div>
</div>